module.exports = __webpack_public_path__ + "static/media/41_B.3599d077.png";